import React, { useState } from 'react'
import { Switch, Route, Redirect, matchPath } from 'react-router-dom'
import { History, Location } from 'history'
import { Container, FullWidthContainerBody } from 'uiComponents/settingsContainer'
import { usePermission } from 'admin/hocs'
import { withFeatures } from 'features'
import { OpeningTimesListPage } from './list'
import OpeningTimesForm from './form'
import OverrideForm from './exceptionsForm'
import { useMessages } from 'messagesContext'
import VenueSectionTabs from 'venue/sectionTabs'
import { NavigationBack } from 'uiComponents/navigation/navigationBack'
import InSectionTabsSlot from 'uiComponents/navigation/sectionTabsSlot'

interface OpeningTimesPageProps {
    history: History
    accountSlug: string
    location: Location
    hasFeature: (feature: string, accountSlug: string) => boolean
}

function OpeningTimesPage(props: OpeningTimesPageProps) {
    const [, setHeader] = useState<string>('Opening Times Configuration')
    const { replaceMessages, removeAllMessages } = useMessages()
    const { hasPermission } = usePermission()

    const setActiveHeader = (headerText: string) => {
        setHeader(headerText)
    }

    const openingTimes = `/account/${props.accountSlug}/venue/opening_times`
    const exceptionMatch = matchPath<{ openingTimesId: string }>(props.location.pathname, {
        path: '/account/:accountSlug/venue/opening_times/exception/:id/default/:openingTimesId',
    })
    const isLocationForm = props.location.pathname.includes('/opening_times/default/')
    const backTo = exceptionMatch
        ? {
              path: `${openingTimes}/default/${exceptionMatch.params.openingTimesId}`,
              text: 'Back to default opening times',
          }
        : { path: `${openingTimes}/locations`, text: 'Back to opening times' }

    return (
        <div style={{ position: 'relative' }} id="opening-hours">
            {isLocationForm || exceptionMatch ? (
                <InSectionTabsSlot>
                    <div className="detail-page-back">
                        <NavigationBack onClick={() => props.history.push(backTo.path)} text={backTo.text} />
                    </div>
                </InSectionTabsSlot>
            ) : (
                <VenueSectionTabs />
            )}
            <Container>
                <Switch location={props.location}>
                    <Route
                        path="/account/:accountSlug/venue/opening_times/locations"
                        render={() => (
                            <FullWidthContainerBody>
                                <OpeningTimesListPage
                                    history={props.history}
                                    setActiveHeader={setActiveHeader}
                                    replaceTopMessages={replaceMessages}
                                    hasPermission={hasPermission}
                                    hasFeature={props.hasFeature}
                                    accountSlug={props.accountSlug}
                                />
                            </FullWidthContainerBody>
                        )}
                    />
                    <Route
                        path="/account/:accountSlug/venue/opening_times/default/:id"
                        exact
                        render={() => (
                            <OpeningTimesForm
                                history={props.history}
                                accountSlug={props.accountSlug}
                                setActiveHeader={setActiveHeader}
                                replaceMessages={replaceMessages}
                                removeAllMessages={removeAllMessages}
                            />
                        )}
                    />
                    <Route
                        path="/account/:accountSlug/venue/opening_times/exception/:id/default/:openingTimesId/"
                        render={() => (
                            <OverrideForm
                                history={props.history}
                                accountSlug={props.accountSlug}
                                setActiveHeader={setActiveHeader}
                                replaceMessages={replaceMessages}
                                removeAllMessages={removeAllMessages}
                            />
                        )}
                    />
                    <Route
                        render={() => <Redirect to={`/account/${props.accountSlug}/venue/opening_times/locations`} />}
                    />
                </Switch>
            </Container>
        </div>
    )
}

export default withFeatures(OpeningTimesPage)
